import { render, staticRenderFns } from "./AnimatedIconInfo.vue?vue&type=template&id=34cda668&scoped=true&"
import script from "./AnimatedIconInfo.vue?vue&type=script&lang=js&"
export * from "./AnimatedIconInfo.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedIconInfo.vue?vue&type=style&index=0&id=34cda668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cda668",
  null
  
)

export default component.exports